@import '../ui-cms-contact-channels-footer';

ui-cms-contact-channels-footer-email {
  display: block;
}
